// Global namespace
window.theme = window.theme || {};

//////////////////////// UTILITY FUNCTIONS //////////////////////////
/**
 * Check Device Type
 * @param {string} typeOf
 * @returns {boolean}
 */

theme.utils = {
  isDevice: (typeOf) => {
    // check different device types and map to window.matchMedia
    const devices = {
      mobile: "(max-width: 480px)",
      tablet: "(min-width: 481px) and (max-width: 768px)",
      desktop: "(min-width: 769px) and (max-width: 979px)",
      largeDesktop: "(min-width: 980px)",
    };

    // check if device type is valid
    if (!devices[typeOf]) {
      throw new Error("Device type is not valid");
    }

    // return true if typeOf matches the window.matchMedia
    return window.matchMedia(devices[typeOf]).matches;
  },

  /**
   * Check if isMobile
   * @returns {boolean}
   */
  isMobile: () => {
    let w =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    if (w <= 768) {
      return true;
    } else {
      return false;
    }
  },

  /**
   * Check if given element is in current viewport
   * @param {selector} el
   * @returns {boolean}
   */
  isInViewport: (el) => {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  },
};
//////////////////////// THEME LAB FUNCTIONS //////////////////////////

// Init Main Javascript
theme.initLab = () => {
  // all custom js init goes here
};

theme.initProductTabs = async (sectionID, productID) => {
  // target specifc section ID for product tabs
  const $productSection = document.querySelector(
    `#ProductSection-${sectionID}-${productID}`
  );
  if (!$productSection) return;
  //get the tab head element
  let tabHeads = $productSection.querySelectorAll(".tabs");
  if (tabHeads.length === 0) return;

  // determine the tab content of the element
  function findTabContent(link) {
    if (link && link.nodeName == "A") {
      let contentID;
      // the modal pop-up is adding '-modal' to the id so we're checking to see if we're in the modal or not
      if ($productSection.classList.contains("is-modal")) {
        contentID = link.attributes.href.value.replace("#", "") + "-modal";
      } else {
        contentID = link.attributes.href.value.replace("#", "");
      }
      return document.getElementById(contentID);
    } else return null;
  }

  function hide(element) {
    if (element) element.style.display = "none";
  }
  function show(element) {
    if (element) element.style.display = "";
  }
  function setActive(element) {
    if (element) {
      element.classList.add("active");
      let c = findTabContent(element);
      show(c);
    }
  }

  tabHeads.forEach(function (tablist) {
    let links = document.querySelectorAll(".tabs a"),
      tabs = document.querySelectorAll(".tabs li");
    if (links.length == 0) return;
    let active = links[0],
      content = findTabContent(active),
      totalWidth = 0,
      currentMode;
    setActive(active);

    links.forEach(function (el, index) {
      if (index > 0) hide(findTabContent(el));
    });

    /* event listener for clicking tabs */
    tablist.addEventListener("click", function (e) {
      let clicked = e.target;
      if (clicked.nodeName !== "A") return;
      e.preventDefault();
      active.classList.remove("active");
      hide(content);
      active = clicked;
      content = findTabContent(clicked);
      setActive(clicked);
      return false;
    });
  });

  // make first tab active
  $productSection.querySelector(".tabs > li a").click();
};

/*************************************************************************************/
/********************************* DO NOT EDIT BELOW *********************************/
/*************************************************************************************/
theme.initLabBranding = () => {
  const brand1 = [
      "background: #000639",
      "padding: 20px",
      "color: #fff",
      "font-size: 1.9em",
      'font-family: "Helvetica Neue", Helvetica, Arial, sans-serif',
      "font-weight: bold",
      "width: 400px",
    ].join(";"),
    brand2 = [
      "background: #fff",
      "padding: 0px",
      "color: #000639",
      "font-size: 1.1em",
      "line-height: 1.2em",
      'font-family: "Helvetica Neue", Helvetica, Arial, sans-serif',
      "font-weight: bold",
      "text-decoration: none",
      "width: 400px",
    ].join(";");
  console &&
    console.log &&
    (console.log("%c shoplab", brand1),
    console.log("%c Shopify Experts \n www.shoplab.cc", brand2));
};

theme.initProductImageSwatcher = async (sectionID, productID) => {
  const $templateSectionSelector = document.querySelector(
    `#ProductSection-${sectionID}-${productID}`
  );
  const $colorSwatchImageWrapper = $templateSectionSelector.querySelector(
    ".color-swatcher-images"
  );

  if (!$colorSwatchImageWrapper) return;

  // definitions
  const currentClusterTag = $templateSectionSelector.dataset.clTag;
  const currentProductHandle = $templateSectionSelector.dataset.productHandle;
  const query = `${currentClusterTag}&resources[type]=product&resources[limit]=9&resources[options][fields]=tag`;

  /**
   * Get product.json data for each product (return actually product)
   * @param {string} query
   * @return {Promise<*>}
   */

  const getProductData = async (query) => {
    try {
      if (!query) return;

      const response = await fetch(`/search/suggest.json?q=${query}`);
      const data = await response.json();
      const products = data.resources.results.products;

      // if currentProductHandle is in products, then set position to first index and return sorted products
      const currentProductIndex = products.findIndex(
        (product) => product.handle === currentProductHandle
      );

      if (currentProductIndex > -1) {
        products.splice(currentProductIndex, 1);
        products.unshift({ handle: currentProductHandle });
      }

      return products;
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Get product color using product.json data (return actually color)
   * @return {Promise}
   */
  const getProductColor = async () => {
    try {
      const products = await getProductData(query);

      if (!products) throw new Error("Failed to fetch products!");

      return await Promise.all(
        products.map(async (product) => {
          const windowLocale = window.Shopify.locale;
          let fetchURL = `/products/${product.handle}.json`;

          if (windowLocale != "de") {
            fetchURL = `/${windowLocale}/products/${product.handle}.json`;
          }

          const response = await fetch(fetchURL);
          const data = await response.json();

          let colorName = data.product.variants[0].option1;

          const itemImageArray = data.product.images;
          const productHandle = data.product.handle;

          let itemColor = colorName;

          // Get first image from the itemImageArray
          const itemImage = itemImageArray[0];

          return {
            productHandle,
            itemImage,
            itemColor,
          };
        })
      );
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Build the html layout and inject it into the DOM
   * @return {Promise<void>}
   */
  const buildHTML = async () => {
    try {
      const colors = await getProductColor();

      if (!colors) return;

      colors.forEach(({ productHandle, itemImage, itemColor }) => {
        // Create the layout
        let htmlLayout = `
                <a class="color-swatch-image-wrapper" href="/products/${productHandle}">
                <div class="image_swatch_wrapper">
                  <img src="${itemImage.src}" alt="${itemImage.alt}" />
                </div>
                  <span class="color">
                    ${itemColor}
                  </span>
                </a>
              `;
        // Inject the HTML
        $colorSwatchImageWrapper.insertAdjacentHTML("beforeend", htmlLayout);

        // First variant border
        let colorVariants = $colorSwatchImageWrapper.getElementsByClassName(
          "color-swatch-image-wrapper"
        )[0];
        colorVariants.classList.add("active");
      });

      //remove skeleton
      $templateSectionSelector
        .querySelector(".content_wrapper")
        .classList.remove("skeleton");
    } catch (error) {
      console.error(error);
    }
  };

  // Paint the DOM
  await buildHTML();
};

/**
 * Custom DOMready function
 * @param {*} callback
 */

theme.DOMready = (callback) => {
  if (document.readyState !== "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
};

/**
 * Use this event listener to run your JS after the DOM is ready
 */
theme.DOMready(() => {
  // Init Main JS
  theme.initLab();
  // Init Branding
  theme.initLabBranding();

  // init product tabs
  theme.initProductTabs();
  // dispatch customEvent
  document.dispatchEvent(new CustomEvent("lab:page-loaded"));

  // HACKS
  // wait for 5 seconds and then run function => hide omnisend
  const omnisendContainer = document.querySelector(
    "#omnisend-dynamic-container"
  );

  if (omnisendContainer) {
    setTimeout(() => {
      omnisendContainer.style.display = "none";
    }, 4000);
  }

  document.addEventListener("quickview:loaded", function (evt) {
    // init image swatcher
    theme.initProductImageSwatcher(evt.detail.productId, evt.detail.id);
    // init tabs
    theme.initProductTabs(evt.detail.productId, evt.detail.id);
  });
});
